(() => {
  if (customElements.get("iconic-video-gallery")) {
    return;
  }

  class IconicVideoGallery extends HTMLElement {
    constructor() {
      super();
      this.initAutoplayVideo = this.initAutoplayVideo.bind(this);
    }

    connectedCallback() {
      this.initAutoplayVideo();
    }

    initAutoplayVideo() {
      const Iconicvideos = this.querySelectorAll("video");

      Iconicvideos.forEach((video) => {
        const videoContainer = video.closest(".iconic-video-grid");
        const playIconSticky = videoContainer.querySelector(
          ".iconic-sticky-play-icon"
        );

        // Toggle play/pause when clicking the video itself
        video.addEventListener("click", function () {
          if (video.paused) {
            video.play();
            if (playIconSticky) {
              playIconSticky.style.display = "none";
            }
          } else {
            video.pause();
            if (playIconSticky) {
              playIconSticky.style.display = "block";
            }
          }
        });

        if (playIconSticky) {
          playIconSticky.addEventListener("click", function () {
            video.play(); // Play the video
            playIconSticky.style.display = "none";
          });
        }
      });
    }
  }

  customElements.define("iconic-video-gallery", IconicVideoGallery);
})();
